import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import {
  PaymentReport,
  PaymentReportFilters,
  PaginatedQuery,
  ExportListType,
  PaymentType,
  PaymentState,
  paymentTypeToHuman,
  paymentStateToHuman,
  paymentRailToHuman,
} from 'ah-api-gateways';
import { formatDate, SIMPLE_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import PaymentDetails from 'ah-payments/src/components/PaymentDetails.vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { usePaymentState } from 'ah-payments';

interface OnboardingListEmits extends UseManagedListingEmits<PaymentReport> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    required: false,
    default: () => ({ tableFields: [] }),
  },
  ...defineUseManagedListingProps<PaymentReport>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const requestManager = useRequestManager();

const paymentState = usePaymentState();



const managedListing = useManagedListing<PaymentReport>({
  loadDataRequest(query: PaginatedQuery<PaymentReportFilters>) {
    /**
     * loadDataRequest will override sort if it is set. Otherwise it defaults to docCreatedAt DESC
     */
    return paymentState.services.payments.listPayments({ ...query });
  },
  downloadDataRequest(type: string, query: { [key: string]: any }, options: { [key: string]: any }) {
    if (options.withDetails) {
      return paymentState.services.payments.downloadListPaymentsWithDetails(query, type as ExportListType);
    }
    return paymentState.services.payments.downloadListPayments(query, type as ExportListType);
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: requestManager.manager,
});

const typeTooltip = (type: PaymentType, tradeId: string = '') => {
  if (type === PaymentType.IMMEDIATE) {
    return 'The payment will be released as soon as there are enough available funds in the wallet ';
  }
  if (type === PaymentType.SCHEDULED) {
    return 'The payment will be released when the scheduled date is reached, as long as there are enough available funds in the wallet ';
  }
  if (type === PaymentType.TRADE_SEND_TO_BENEFICIARY) {
    return `The payment will be released as soon as trade ${tradeId} is settled`;
  }
  return '';
};

const stateTooltip = (state: PaymentState) => {
  switch (state) {
    case PaymentState.REGISTERED:
      return "We're checking your payment to make sure everything is in order.";
    case PaymentState.IN_REVIEW:
      return "We're reviewing your payment as part of our routine checks.";
    case PaymentState.REJECTED:
      return "Sorry, your payment didn't pass our review and can't be sent. Contact support for more information.";
    case PaymentState.APPROVED:
      return 'Your payment passed our review and is in progress.';
    case PaymentState.IN_PROCESS:
      return 'Your payment is in progress.';
    case PaymentState.CONFIRMED:
      return 'Your payment has been sent and the money has left your account.';
    case PaymentState.FAILED:
      return 'There was a problem sending your payment. Contact support for more information.';
    case PaymentState.PENDING:
      return ' Your payment has been set up and is in the payment queue.';
    case PaymentState.QUEUED:
      return 'Your payment is awaiting sufficient funds in to be deposited. Payment process will commence when your balance is high enough.';
    default:
      return '';
  }
};

expose({ loadData: managedListing.loadData, downloadData: managedListing.listeners.download });

return { __sfc: true,props, requestManager, paymentState, emit, managedListing, typeTooltip, stateTooltip, paymentTypeToHuman, paymentStateToHuman, paymentRailToHuman, formatDate, SIMPLE_DATE_FORMAT, PaymentDetails, formatCurrencyValue }
}

})